import { i18n } from '../../i18n/translate';
import type { MenuItem } from './types';

export const nextLearnerMenu = (): MenuItem => {
  return {
    id: 'content-menu',
    type: 'menus',
    css_class: 'content-cog-shell',
    weight: 100,
    submenu_items: [
      {
        title: i18n.t('Settings'),
        icon: 'gear',
        css_class: 'content-cog',
        new_window: false,
        subsection: false,
        target_url: '',
        slug: '',
        submenu_items: [
          {
            id: 'in_course-help',
            title: i18n.t('Help'),
            icon: 'circle-question',
            target_url: 'help_modal',
            new_window: false,
            slug: '',
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'in_course-terms_of_service',
            title: i18n.t('Terms of Service'),
            icon: 'file',
            target_url: 'https://everfi.com/terms-of-service',
            new_window: true,
            slug: '',
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'in_course-accessibility',
            title: i18n.t('Accessibility'),
            icon: 'wheelchair',
            target_url: 'https://everfi.com/accessibility',
            new_window: true,
            slug: '',
            submenu_items: [],
            weight: 100,
          },
          {
            id: 'language-menu-button',
            title: i18n.t('Language'),
            icon: 'language',
            target_url: 'language_modal',
            weight: 100,
            new_window: false,
            slug: '',
            submenu_items: [],
          },
          {
            id: 'in_course-home',
            title: i18n.t('Home'),
            icon: 'house-chimney',
            target_url: '/',
            new_window: false,
            slug: '',
            submenu_items: [],
            weight: 100,
          },
        ],
      },
    ],
  };
};
